import React from 'react';
import DetailsTitle from '../DetailsTitle';
import DetailsField from '../DetailsField';
import { selectedFromOptionsToString } from '../../../../lib/collection.utils';
import { msToTime } from '../../../../lib/date.utils';

const ContactShow = ({ data, contextOptions, dependencies }) => (
    <React.Fragment>
        <DetailsTitle title={data.fullName} image={data.image} />
        <div className="ckp-admin-forms-body">
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column is-contained is-2-3 u-full-height">
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Email" value={data.email} link={`mailto: ${data.email}`} />
                        {data.phones.map((p, i) => (
                            <DetailsField key={i} field={p.k} value={p.v} link={`tel: ${p.v}`} />
                        ))}
                        <DetailsField
                            field="Organizations"
                            value={selectedFromOptionsToString(contextOptions, data.organizationIds)}
                        />
                        <DetailsField
                            field="Media Partners"
                            value={selectedFromOptionsToString(dependencies.partners, data.partnerIds)}
                        />
                        <DetailsField
                            field="Artists"
                            value={selectedFromOptionsToString(dependencies.artists, data.artistIds)}
                        />
                    </div>
                    <div className="u-margin-bottom-3">
                        {data.socialMedia.map((sm, i) => (
                            <DetailsField key={i} field={sm.k} value={sm.v} link={`${sm.v}`} target="_blank" />
                        ))}
                    </div>
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Website" value={data.website} link={data.website} target="_blank" />
                    </div>
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Last Login" value={msToTime(data.lastLoginAt, true)} />
                        <DetailsField field="Last Login IP" value={data.lastLoginIp} />
                    </div>
                </div>
                <div className="ckp-admin-grid-column is-contained is-1-3 u-full-height">
                    <h3 className="ckp-ts-h3 u-bold u-margin-bottom-2">Note</h3>
                    <div>{data.note}</div>
                </div>
            </div>
        </div>
    </React.Fragment>
);

export default ContactShow;
